import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { SearchIcon, CalendarIcon, UserIcon, TagIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const blogPosts = [{
  id: 1,
  title: "Les opportunités d'affaires dans le secteur des énergies renouvelables en Afrique",
  excerpt: "L'Afrique connaît une révolution dans le domaine des énergies renouvelables. Découvrez les opportunités pour les entreprises françaises.",
  image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '15 mai 2023',
  author: 'Marie Laurent',
  authorImage: 'https://randomuser.me/api/portraits/women/44.jpg',
  category: 'Énergie',
  tags: ['Énergies renouvelables', 'Afrique', 'Investissements'],
  featured: true
}, {
  id: 2,
  title: "Guide pratique : Comment répondre aux appels d'offres en Afrique de l'Ouest",
  excerpt: "Les appels d'offres en Afrique de l'Ouest ont leurs spécificités. Voici un guide pratique pour maximiser vos chances de succès.",
  image: 'https://images.unsplash.com/photo-1554774853-aae0a22c8aa4?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '3 avril 2023',
  author: 'Thomas Dubois',
  authorImage: 'https://randomuser.me/api/portraits/men/32.jpg',
  category: 'Conseils',
  tags: ["Appels d'offres", "Afrique de l'Ouest", 'Guide pratique']
}, {
  id: 3,
  title: "Le boom de la construction en Afrique de l'Est : opportunités pour les entreprises françaises",
  excerpt: "L'Afrique de l'Est connaît un boom immobilier sans précédent. Quelles sont les opportunités pour les entreprises françaises du BTP ?",
  image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '21 mars 2023',
  author: 'Sophie Moreau',
  authorImage: 'https://randomuser.me/api/portraits/women/65.jpg',
  category: 'BTP',
  tags: ['Construction', "Afrique de l'Est", 'Immobilier']
}, {
  id: 4,
  title: 'Les nouvelles réglementations sur les marchés publics au Maroc',
  excerpt: 'Le Maroc a récemment réformé sa réglementation sur les marchés publics. Quels impacts pour les entreprises étrangères ?',
  image: 'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '15 février 2023',
  author: 'Jean-Philippe Martin',
  authorImage: 'https://randomuser.me/api/portraits/men/75.jpg',
  category: 'Réglementation',
  tags: ['Maroc', 'Marchés publics', 'Réglementation']
}, {
  id: 5,
  title: 'Le secteur de la santé en Afrique : tendances et opportunités',
  excerpt: 'Le secteur de la santé africain connaît une transformation rapide. Découvrez les tendances et opportunités pour les entreprises françaises.',
  image: 'https://images.unsplash.com/photo-1551076805-e1869033e561?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '5 janvier 2023',
  author: 'Aminata Touré',
  authorImage: 'https://randomuser.me/api/portraits/women/32.jpg',
  category: 'Santé',
  tags: ['Santé', 'Afrique', 'Investissements']
}, {
  id: 6,
  title: 'Comment établir des partenariats solides avec des entreprises africaines',
  excerpt: 'Les partenariats locaux sont souvent la clé du succès en Afrique. Voici comment établir des relations durables avec des entreprises africaines.',
  image: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
  date: '10 décembre 2022',
  author: 'Abdoulaye Diallo',
  authorImage: 'https://randomuser.me/api/portraits/men/68.jpg',
  category: 'Conseils',
  tags: ['Partenariats', 'Stratégie', 'Développement']
}];
const categories = [{
  name: 'Tous',
  count: blogPosts.length
}, {
  name: 'Énergie',
  count: 1
}, {
  name: 'Conseils',
  count: 2
}, {
  name: 'BTP',
  count: 1
}, {
  name: 'Réglementation',
  count: 1
}, {
  name: 'Santé',
  count: 1
}];
const featuredPost = blogPosts.find(post => post.featured);
const regularPosts = blogPosts.filter(post => !post.featured);
export function BlogPage() {
  const [activeCategory, setActiveCategory] = useState('Tous');
  const [searchQuery, setSearchQuery] = useState('');
  const filteredPosts = regularPosts.filter(post => {
    // Filter by category
    if (activeCategory !== 'Tous' && post.category !== activeCategory) {
      return false;
    }
    // Filter by search query
    if (searchQuery.trim() !== '') {
      const query = searchQuery.toLowerCase();
      return post.title.toLowerCase().includes(query) || post.excerpt.toLowerCase().includes(query) || post.tags.some(tag => tag.toLowerCase().includes(query));
    }
    return true;
  });
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-1535">
      <Navbar data-id="element-1536" />
      <main className="pt-20" data-id="element-1537">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-20 relative overflow-hidden" data-id="element-1538">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10" data-id="element-1539">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-1540">
              <defs data-id="element-1541">
                <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-1542">
                  <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-1543" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#grid)" data-id="element-1544" />
            </svg>
          </div>
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-blue-800 rounded-full opacity-30 transform translate-x-1/3 -translate-y-1/3" data-id="element-1545"></div>
          <div className="absolute bottom-0 left-0 w-1/4 h-1/4 bg-yellow-500 rounded-full opacity-20 transform -translate-x-1/3 translate-y-1/3" data-id="element-1546"></div>
          <div className="container mx-auto px-4 relative z-10" data-id="element-1547">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1548">
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-1549">
                Notre Blog
              </h1>
              <p className="text-xl text-blue-100 mb-8" data-id="element-1550">
                Analyses, conseils et actualités sur les opportunités d'affaires
                en Afrique.
              </p>
              {/* Search Bar */}
              <div className="max-w-xl mx-auto relative" data-id="element-1551">
                <input type="text" placeholder="Rechercher un article..." className="w-full px-4 py-3 pl-12 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-yellow-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-1552" />
                <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1553" />
              </div>
            </div>
          </div>
        </section>
        {/* Featured Post */}
        {featuredPost && <section className="py-16" data-id="element-1554">
            <div className="container mx-auto px-4" data-id="element-1555">
              <div className="max-w-6xl mx-auto" data-id="element-1556">
                <div className="flex items-center mb-8" data-id="element-1557">
                  <span className="inline-block px-3 py-1 bg-yellow-100 text-yellow-800 text-sm font-semibold rounded-full mr-4" data-id="element-1558">
                    À la une
                  </span>
                  <div className="h-px bg-gray-200 flex-grow" data-id="element-1559"></div>
                </div>
                <motion.div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5
            }} viewport={{
              once: true
            }} data-id="element-1560">
                  <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-1561">
                    <div className="h-64 lg:h-auto overflow-hidden" data-id="element-1562">
                      <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-full object-cover" data-id="element-1563" />
                    </div>
                    <div className="p-8" data-id="element-1564">
                      <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-1565">
                        <div className="flex items-center mr-4" data-id="element-1566">
                          <CalendarIcon size={14} className="mr-1" data-id="element-1567" />
                          <span data-id="element-1568">{featuredPost.date}</span>
                        </div>
                        <div className="flex items-center" data-id="element-1569">
                          <TagIcon size={14} className="mr-1" data-id="element-1570" />
                          <span data-id="element-1571">{featuredPost.category}</span>
                        </div>
                      </div>
                      <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-4 leading-tight" data-id="element-1572">
                        {featuredPost.title}
                      </h2>
                      <p className="text-gray-700 mb-6" data-id="element-1573">
                        {featuredPost.excerpt}
                      </p>
                      <div className="flex items-center justify-between" data-id="element-1574">
                        <div className="flex items-center" data-id="element-1575">
                          <div className="w-10 h-10 rounded-full overflow-hidden mr-3" data-id="element-1576">
                            <img src={featuredPost.authorImage} alt={featuredPost.author} className="w-full h-full object-cover" data-id="element-1577" />
                          </div>
                          <span className="text-sm font-medium text-gray-700" data-id="element-1578">
                            {featuredPost.author}
                          </span>
                        </div>
                        <Button variant="secondary" className="flex items-center" data-id="element-1579">
                          <span data-id="element-1580">Lire l'article</span>
                          <ArrowRightIcon size={16} className="ml-2" data-id="element-1581" />
                        </Button>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </section>}
        {/* Blog Content */}
        <section className="py-16 bg-gray-50" data-id="element-1582">
          <div className="container mx-auto px-4" data-id="element-1583">
            <div className="max-w-6xl mx-auto" data-id="element-1584">
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-8" data-id="element-1585">
                {/* Sidebar */}
                <div className="lg:col-span-1" data-id="element-1586">
                  <div className="bg-white rounded-xl shadow-md p-6 sticky top-24" data-id="element-1587">
                    <h3 className="text-lg font-bold text-blue-900 mb-4" data-id="element-1588">
                      Catégories
                    </h3>
                    <ul className="space-y-2" data-id="element-1589">
                      {categories.map(category => <li key={category.name} data-id="element-1590">
                          <button className={`w-full text-left px-3 py-2 rounded-md flex justify-between items-center text-sm ${activeCategory === category.name ? 'bg-blue-100 text-blue-900 font-medium' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setActiveCategory(category.name)} data-id="element-1591">
                            <span data-id="element-1592">{category.name}</span>
                            <span className="bg-gray-100 text-gray-600 rounded-full px-2 py-0.5 text-xs" data-id="element-1593">
                              {category.count}
                            </span>
                          </button>
                        </li>)}
                    </ul>
                    <div className="mt-8" data-id="element-1594">
                      <h3 className="text-lg font-bold text-blue-900 mb-4" data-id="element-1595">
                        Tags populaires
                      </h3>
                      <div className="flex flex-wrap gap-2" data-id="element-1596">
                        {Array.from(new Set(blogPosts.flatMap(post => post.tags))).slice(0, 10).map(tag => <span key={tag} className="inline-block px-3 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full cursor-pointer hover:bg-blue-100" onClick={() => setSearchQuery(tag)} data-id="element-1597">
                              {tag}
                            </span>)}
                      </div>
                    </div>
                    <div className="mt-8 bg-blue-50 p-4 rounded-lg" data-id="element-1598">
                      <h3 className="text-lg font-bold text-blue-900 mb-2" data-id="element-1599">
                        Newsletter
                      </h3>
                      <p className="text-sm text-gray-700 mb-4" data-id="element-1600">
                        Recevez nos derniers articles et analyses directement
                        dans votre boîte mail.
                      </p>
                      <div className="space-y-2" data-id="element-1601">
                        <input type="email" placeholder="Votre email" className="w-full px-3 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm" data-id="element-1602" />
                        <Button variant="primary" size="sm" fullWidth className="shadow-sm shadow-yellow-500/20" data-id="element-1603">
                          S'abonner
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Articles Grid */}
                <div className="lg:col-span-3" data-id="element-1604">
                  {searchQuery && <div className="mb-6" data-id="element-1605">
                      <p className="text-gray-700" data-id="element-1606">
                        {filteredPosts.length} résultat(s) pour{' '}
                        <span className="font-medium" data-id="element-1607">"{searchQuery}"</span>
                        <button className="ml-2 text-blue-600 hover:underline text-sm" onClick={() => setSearchQuery('')} data-id="element-1608">
                          Effacer
                        </button>
                      </p>
                    </div>}
                  {filteredPosts.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1609">
                      {filteredPosts.map((post, index) => <motion.article key={post.id} className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 transition-transform hover:-translate-y-1 hover:shadow-lg" initial={{
                    opacity: 0,
                    y: 20
                  }} whileInView={{
                    opacity: 1,
                    y: 0
                  }} transition={{
                    duration: 0.4,
                    delay: index * 0.1
                  }} viewport={{
                    once: true
                  }} data-id="element-1610">
                          <div className="h-48 overflow-hidden" data-id="element-1611">
                            <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-1612" />
                          </div>
                          <div className="p-6" data-id="element-1613">
                            <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-1614">
                              <div className="flex items-center mr-4" data-id="element-1615">
                                <CalendarIcon size={14} className="mr-1" data-id="element-1616" />
                                <span data-id="element-1617">{post.date}</span>
                              </div>
                              <div className="flex items-center" data-id="element-1618">
                                <TagIcon size={14} className="mr-1" data-id="element-1619" />
                                <span data-id="element-1620">{post.category}</span>
                              </div>
                            </div>
                            <h3 className="text-xl font-bold text-blue-900 mb-3 leading-tight" data-id="element-1621">
                              {post.title}
                            </h3>
                            <p className="text-gray-700 text-sm mb-4" data-id="element-1622">
                              {post.excerpt}
                            </p>
                            <div className="flex items-center justify-between" data-id="element-1623">
                              <div className="flex items-center" data-id="element-1624">
                                <div className="w-8 h-8 rounded-full overflow-hidden mr-2" data-id="element-1625">
                                  <img src={post.authorImage} alt={post.author} className="w-full h-full object-cover" data-id="element-1626" />
                                </div>
                                <span className="text-xs font-medium text-gray-700" data-id="element-1627">
                                  {post.author}
                                </span>
                              </div>
                              <a href="#" className="text-blue-600 text-sm font-medium hover:underline flex items-center" data-id="element-1628">
                                <span data-id="element-1629">Lire</span>
                                <ArrowRightIcon size={14} className="ml-1" data-id="element-1630" />
                              </a>
                            </div>
                          </div>
                        </motion.article>)}
                    </div> : <div className="bg-white rounded-xl shadow-md p-8 text-center" data-id="element-1631">
                      <div className="text-gray-400 mb-4" data-id="element-1632">
                        <SearchIcon size={48} className="mx-auto" data-id="element-1633" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-700 mb-2" data-id="element-1634">
                        Aucun résultat trouvé
                      </h3>
                      <p className="text-gray-600 mb-4" data-id="element-1635">
                        Nous n'avons pas trouvé d'articles correspondant à votre
                        recherche.
                      </p>
                      <Button variant="secondary" onClick={() => {
                    setSearchQuery('');
                    setActiveCategory('Tous');
                  }} data-id="element-1636">
                        Réinitialiser les filtres
                      </Button>
                    </div>}
                  {/* Pagination */}
                  {filteredPosts.length > 0 && <div className="flex justify-center mt-12" data-id="element-1637">
                      <nav className="flex items-center space-x-2" data-id="element-1638">
                        <button className="w-10 h-10 rounded-md flex items-center justify-center border border-gray-300 text-gray-500 hover:border-blue-600 hover:text-blue-600" data-id="element-1639">
                          <ChevronLeftIcon size={18} data-id="element-1640" />
                        </button>
                        <button className="w-10 h-10 rounded-md flex items-center justify-center bg-blue-600 text-white font-medium" data-id="element-1641">
                          1
                        </button>
                        <button className="w-10 h-10 rounded-md flex items-center justify-center border border-gray-300 text-gray-700 hover:border-blue-600 hover:text-blue-600" data-id="element-1642">
                          2
                        </button>
                        <button className="w-10 h-10 rounded-md flex items-center justify-center border border-gray-300 text-gray-700 hover:border-blue-600 hover:text-blue-600" data-id="element-1643">
                          3
                        </button>
                        <span className="text-gray-500" data-id="element-1644">...</span>
                        <button className="w-10 h-10 rounded-md flex items-center justify-center border border-gray-300 text-gray-700 hover:border-blue-600 hover:text-blue-600" data-id="element-1645">
                          8
                        </button>
                        <button className="w-10 h-10 rounded-md flex items-center justify-center border border-gray-300 text-gray-500 hover:border-blue-600 hover:text-blue-600" data-id="element-1646">
                          <ChevronRightIcon size={18} data-id="element-1647" />
                        </button>
                      </nav>
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1648" />
    </div>;
}